export default "__VITE_ASSET__YM09fe8k__"